import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'vTrasyApi/';

export default {

    getWszytskiePrzystankiNaTrasie(idTr) {
        return axios({
            method: 'get',
            url: URL + idTr,
        });
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/vTrasyService.js